import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

/**
 * Terms of Service. Linked from the marketing footer + signup flow.
 * Content lives in `legal.terms_*` translation keys so it can be edited
 * without code changes.
 */
export default function TermsPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-surface-page">
      <header className="border-b border-slate-200 bg-surface">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
          <Link
            to="/"
            className="text-xl font-bold text-slate-900 hover:text-primary"
          >
            {t("app.title")}
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-12 prose prose-slate">
        <h1>{t("legal.terms_title")}</h1>
        <p className="text-sm text-slate-500">{t("legal.last_updated")}</p>
        <p className="lead">{t("legal.terms_lead")}</p>

        <h2>{t("legal.terms_service_title")}</h2>
        <p>{t("legal.terms_service_body")}</p>

        <h2>{t("legal.terms_payment_title")}</h2>
        <p>{t("legal.terms_payment_body")}</p>

        <h2>{t("legal.terms_acceptable_use_title")}</h2>
        <p>{t("legal.terms_acceptable_use_body")}</p>

        <h2>{t("legal.terms_liability_title")}</h2>
        <p>{t("legal.terms_liability_body")}</p>

        <h2>{t("legal.terms_termination_title")}</h2>
        <p>{t("legal.terms_termination_body")}</p>

        <p className="text-sm text-slate-500">{t("legal.draft_warning")}</p>
      </main>
    </div>
  );
}
